// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-wrapper[data-v-4c8a4d8c] {\n  position: relative;\n  background: #E8EEF1;\n}\n.copy-btn[data-v-4c8a4d8c] {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  margin-top: -14px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
